import PropTypes from 'prop-types';

import Box from 'shopper/components/Box';

import CarouselBox from 'components/CarouselBox';

import { sendEvent } from 'lib/gtag';

import CategoriesCarouselItem from './CategoriesCarouselItem';

const CategoriesCarousel = ({ gaEventCategory, threadsCategories }) => {
  const onCategoryClick = (categorySlug) =>
    sendEvent({
      category: gaEventCategory,
      action: 'filter_tag',
      value: categorySlug,
    });

  return (
    <Box className="mb-6 px-3" full>
      <CarouselBox
        arrowsProps={{
          className: 'hidden md:flex',
          offsetX: { left: '-left-2', right: '-right-2' },
        }}
        carouselProps={{
          className: 'w-full md:w-[90%]',
        }}
        itemProps={{
          breakpoints: {
            lg: {
              slidesPerView: 5,
              itemSize: 85,
            },
            xl: {
              slidesPerView: 6,
              itemSize: 88,
            },
          },
          slidesPerView: 2,
          itemSize: 80,
          snapMode: 'snap-center',
        }}
        list={threadsCategories}
        render={({ categorySlug, categoryTitle }) => (
          <CategoriesCarouselItem
            categoryIcon={categorySlug}
            categorySlug={categorySlug}
            categoryTitle={categoryTitle}
            onClick={() => onCategoryClick(categorySlug)}
          />
        )}
        showArrows
      />
    </Box>
  );
};

CategoriesCarousel.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  threadsCategories: PropTypes.arrayOf(
    PropTypes.shape({
      categoryId: PropTypes.number.isRequired,
      categorySlug: PropTypes.string.isRequired,
      categoryTitle: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default CategoriesCarousel;
